export default __webpack_public_path__ + "static/media/FocusTimer.fb7df93523be12a7d48d2c75943c2923.webp";